import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@principle-theorem/ng-auth';
import {
  DayOfWeek,
  isEnumValue,
  TIME_FORMAT,
  TIME_FORMAT_24HR,
} from '@principle-theorem/shared';
import { startCase } from 'lodash';
import { queryParam$ } from '@principle-theorem/ng-shared';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserRestrictedReason } from '@principle-theorem/ng-principle-shared';
import * as moment from 'moment-timezone';

@Component({
  selector: 'pr-user-restricted',
  templateUrl: './user-restricted.component.html',
  styleUrl: './user-restricted.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserRestrictedComponent {
  restrictionReason$: Observable<UserRestrictedReason | undefined>;
  restrictedUntil$: Observable<moment.Moment | undefined>;
  restrictedUntilDay$: Observable<string | undefined>;
  timeRestriction = UserRestrictedReason.Time;
  dayRestriction = UserRestrictedReason.Day;
  ipRestriction = UserRestrictedReason.IP;
  timeFormat = TIME_FORMAT;

  constructor(
    private _auth: AuthService,
    private _route: ActivatedRoute
  ) {
    this.restrictionReason$ = queryParam$(this._route, 'reason').pipe(
      map((reason) =>
        isEnumValue(UserRestrictedReason, reason) ? reason : undefined
      )
    );
    this.restrictedUntil$ = queryParam$(this._route, 'restrictedUntil').pipe(
      map((time) => {
        const restrictedUntil = moment(time, TIME_FORMAT_24HR);
        return restrictedUntil.isValid() ? restrictedUntil : undefined;
      })
    );
    this.restrictedUntilDay$ = queryParam$(
      this._route,
      'restrictedUntilDay'
    ).pipe(
      map((day) => (isEnumValue(DayOfWeek, day) ? startCase(day) : undefined))
    );
  }

  async logout(): Promise<void> {
    return this._auth.logout();
  }
}
